// extracted by mini-css-extract-plugin
export var actionButton = "_97-0";
export var attachmentLine = "_97-1";
export var fileInput = "_97-2";
export var fileUploadWrapper = "_97-4";
export var footer = "_97-3";
export var modalContent = "_97-5";
export var paperclip = "_97-6";
export var quillEditor = "_97-7";